import { createContext } from "react";

const FcrfContext = createContext(null);

export default FcrfContext;
